import * as React from 'react';
import { ComplexValue } from 'app/types-shared';
import { DisplayCodes } from 'ui';
import { BowtieTranslation } from '../../constants';

import style from './tooltip-evaluations.scss';

interface TooltipEvaluationsProps {
  caseNumber: number;
  evaluation: ComplexValue<number>[];
  fetching: boolean;
  translation: BowtieTranslation;
}

export class TooltipEvaluations extends React.PureComponent<TooltipEvaluationsProps> {

  private renderEvaluation = () => {

    const { caseNumber, evaluation } = this.props;

    return <div className={`flex-wrap ${style.evaluationContainer}`}>
      {evaluation.map(e =>
        <span key={e.value}>
          <DisplayCodes
            componentId={`evaluation-${caseNumber}-${e.value}`}
            className={undefined}
            style="secondary"
            valueItems={[e]}
            displayIcon={'left'}
            options={undefined}
            onChange={undefined}
          />
        </span>)}
    </div>;
  };

  public render() {
    const { evaluation, fetching, translation } = this.props;

    if (!evaluation) {
      return null;
    }

    return <>
      <p className="tooltip-header">
        <b>{translation.inspection_evaluation}:</b>
      </p>

      {fetching
        ? <p>{translation.fetching_evaluation}</p>
        : !evaluation || evaluation.length === 0
          ? <p>{translation.no_evaluation_data}</p>
          : this.renderEvaluation()}
    </>;
  }
}
